<template>
  <NDialog v-bind="$attrs" v-on="$listeners" customClass="ptDialog" bodyPadding="0px">
    <div slot="title" class="iconBlock" v-if="showIcon">
      <img :src="imgUrl" :alt="type" />
    </div>
    <div class="content-box">
      <div class="subTitle">{{ subTitle }}</div>
      <div class="content"><slot name="content"></slot></div>
    </div>
  </NDialog>
</template>
<script>
import NDialog from '@/components/NDialog.vue';
export default {
  name: 'PtInfoDialog',
  components: { NDialog },
  props: {
    type: { type: String, default: 'success' },
    showIcon: { type: Boolean, default: true },
    subTitle: { type: String, default: '' }
  },
  data() {
    return {};
  },
  computed: {
    imgUrl() {
      switch (this.type) {
        case 'success':
          return require('@/assets/images/propTrade/dialog_success.png');
        case 'warning':
        case 'fail':
          return require('@/assets/images/propTrade/dialog_fail.png');
        default:
          return require('@/assets/images/propTrade/dialog_success.png');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.iconBlock {
  text-align: center;
  margin-top: 32px;
  img {
    width: 70px;
    height: 70px;
  }
}
.content {
  color: #232020;
  line-height: 23px;
  text-align: center;
  font-size: 16px;
}
.subTitle {
  font-size: 20px;
  font-weight: 700;
  color: $title-color;
  text-align: center;
  margin: 8px 0 20px 0;
}
/deep/ .button-wrapper {
  display: flex;
  padding-top: 32px;
  gap: 15px;
  button {
    width: 100%;
    border-radius: 30px;
  }
}
</style>
